import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../css/footer.css";

import phoneAndroid from "../../image/amobile.png";
import phoneAndroidHotel from "../../image/amobile2.png";
import phoneIos from "../../image/imobile.png";
import phoneIosHotel from "../../image/imobile2.png";
import { PAYMENT_METHODS } from "../../constants/paymentMethods";

export const Footer = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [revealed, setRevealed] = useState(false);

  /* Fade-in / reveal */
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    if (!("IntersectionObserver" in window)) {
      setRevealed(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setRevealed(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -80px 0px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  /* Trimmed to 4 links per column, all routes verified in applicationRoutes.js */
  const QUICK = [
    { label: "Contact Us", path: "/contact" },
    { label: "Blog", path: "/blogs" },
    { label: "All Venues", path: "/all-facilities" },
    { label: "How it Works", path: "/how-to-works" },
  ];
  const SUPPORT = [
    { label: "FAQs", path: "/faq" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Terms & Conditions", path: "/terms-and-conditions" },
    { label: "Refund Policy", path: "/refund-cancellation-policy" },
  ];
  const VENUES = [
    {
      label: "List Your Court",
      href: "https://admin.bookvenue.app/createFacility",
      external: true,
    },
    {
      label: "Venue Dashboard",
      href: "https://admin.bookvenue.app",
      external: true,
    },
    {
      label: "Manage Bookings",
      href: "https://admin.bookvenue.app",
      external: true,
    },
    { label: "Partner With Us", path: "/contact" },
  ];

  const renderItem = (it) => {
    if (it.external) {
      return (
        <a href={it.href} target="_blank" rel="noopener noreferrer">
          {it.label}
        </a>
      );
    }
    return (
      <button type="button" onClick={() => navigate(it.path)}>
        {it.label}
      </button>
    );
  };

  return (
    <footer
      ref={sectionRef}
      className={`bv-foot ${revealed ? "is-revealed" : ""}`}
      aria-labelledby="bv-foot-cta-title"
    >
      <div className="bv-foot__cta-wrap">
        <div className="bv-foot__cta">
          <span className="bv-foot__cta-eyebrow">
            <i className="fa-solid fa-mobile-screen-button"></i>
            BookVenue Mobile App
          </span>
          <h2
            id="bv-foot-cta-title"
            className="bv-section-title bv-foot__cta-title"
          >
            Your all-in-one <span className="gradientText">Booking App</span>
          </h2>
          <p className="bv-foot__cta-lede">
            From hotel stays to sports venues, discover your perfect place,
            check availability, and book in seconds. Download the app and get{" "}
            <strong>₹20 FLAT OFF</strong> on your first booking.
          </p>

          <div className="bv-foot__cta-stores">
            <Link
              to="https://play.google.com/store/apps/details?id=com.shivamnegi.bookvenue"
              target="_blank"
              className="bv-foot__cta-store"
            >
              <i className="fa-brands fa-google-play"></i>
              <span>
                <em>GET IT ON</em>
                Google Play
              </span>
            </Link>
            <Link
              to="https://apps.apple.com/us/app/bookvenue/id6755186865"
              target="_blank"
              className="bv-foot__cta-store"
            >
              <i className="fa-brands fa-apple"></i>
              <span>
                <em>Download on the</em>
                App Store
              </span>
            </Link>
          </div>
          {/* Fanned phone mockups — real screenshots with fade-out edges */}
          <div className="bv-foot__cta-fan" aria-hidden="true">
            <div className="bv-foot__phone bv-foot__phone--p1">
              <img src={phoneAndroidHotel} alt="" />
            </div>
            <div className="bv-foot__phone bv-foot__phone--p2">
              <img src={phoneIosHotel} alt="" />
            </div>
            <div className="bv-foot__phone bv-foot__phone--p3">
              <img src={phoneAndroidHotel} alt="" />
            </div>
            <div className="bv-foot__phone bv-foot__phone--p4">
              <img src={phoneIosHotel} alt="" />
            </div>
            <div className="bv-foot__phone bv-foot__phone--p5">
              <img src={phoneAndroidHotel} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="bv-foot__cols-wrap">
        <div className="bv-foot__brand-col">
          <button
            type="button"
            className="bv-foot__brand"
            onClick={() => navigate("/")}
          >
            <img
              className="bv-foot__brand-logo"
              src="/final-bv-logo.png"
              alt="BookVenue"
            />
          </button>

          <div className="bv-foot__pay">
            <ul
              className="bv-foot__pay-logos"
              aria-label="Accepted payment methods"
            >
              {PAYMENT_METHODS.map((method) => (
                <li key={method.id}>
                  <img
                    src={method.src}
                    alt={method.label}
                    title={method.label}
                    loading="lazy"
                    decoding="async"
                  />
                </li>
              ))}
            </ul>
          </div>

          <p className="bv-foot__brand-desc">
            India's trusted booking marketplace for hotels and sports venues.
            Discover, compare, and book hotels, resorts, turfs, courts, and
            grounds — all in one place.
          </p>
          <div className="bv-foot__social">
            {[
              {
                i: "fa-brands fa-facebook-f",
                url: "https://facebook.com/bookvenue",
              },
              {
                i: "fa-brands fa-x-twitter",
                url: "https://twitter.com/bookvenue",
              },
              {
                i: "fa-brands fa-instagram",
                url: "https://instagram.com/bookvenue",
              },
              { i: "fa-brands fa-linkedin-in", url: "https://linkedin.com" },
            ].map((s) => (
              <a
                key={s.i}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="social"
              >
                <i className={s.i}></i>
              </a>
            ))}
          </div>
        </div>

        <div className="bv-foot__cols">
          <div className="bv-foot__col">
            <h4>Quick Links</h4>
            <ul>
              {QUICK.map((it) => (
                <li key={it.label}>{renderItem(it)}</li>
              ))}
            </ul>
          </div>

          <div className="bv-foot__col">
            <h4>Support</h4>
            <ul>
              {SUPPORT.map((it) => (
                <li key={it.label}>{renderItem(it)}</li>
              ))}
            </ul>
          </div>

          <div className="bv-foot__col">
            <h4>For Venues</h4>
            <ul>
              {VENUES.map((it) => (
                <li key={it.label}>{renderItem(it)}</li>
              ))}
            </ul>
          </div>

          <div className="bv-foot__col">
            <h4>Contact Us</h4>
            <ul className="bv-foot__contact">
              <li>
                <i className="fa-solid fa-location-dot"></i>
                <span>
                  Sujok Building, 2nd floor, Mansarovar Colony, Ballupur,
                  Dehradun, Uttarakhand 248001
                </span>
              </li>
              <li>
                <i className="fa-solid fa-phone"></i>
                <a href="tel:+917500872014">+91-7500872014</a>
              </li>
              <li>
                <i className="fa-solid fa-envelope"></i>
                <a href="mailto:admin@bookvenue.app">admin@bookvenue.app</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bv-foot__bottom">
        <p>© {new Date().getFullYear()} BookVenue. All rights reserved.</p>
        <div className="bv-foot__legal">
          <button
            type="button"
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms
          </button>
          <span>·</span>
          <button type="button" onClick={() => navigate("/privacy-policy")}>
            Privacy
          </button>
          <span>·</span>
          <button
            type="button"
            onClick={() => navigate("/refund-cancellation-policy")}
          >
            Refunds
          </button>
        </div>
      </div>

      <div className="bv-foot__credit">
        <p>
          Designed &amp; Developed by{" "}
          <a
            href="https://giksindia.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            GIKS INDIA PVT LTD
          </a>
        </p>
      </div>
    </footer>
  );
};
